/* Mega menu showcase
   - Ett block per kategori med en bild
   - Hover på en länk visar länkens bild, bilden återställs när musen lämnar listan
   - Mega-menyn öppnas vid hover på desktop (som DJI Enterprise) */

if (!customElements.get('mega-menu-showcase')) {
  class MegaMenuShowcase extends HTMLElement {
    connectedCallback() {
      let overrides = {};
      try {
        const el = document.getElementById('MegaMenuImages');
        if (el) overrides = JSON.parse(el.textContent || '{}');
      } catch (e) {
        overrides = {};
      }

      // Antal kategorier per rad (block "Kolumner per rad")
      const firstBlock = this.querySelector('.mms__block');
      const menuKey = this.dataset.mmsParent || (firstBlock ? (firstBlock.dataset.mmsKey || '').split('|')[0] : '');
      const colsData = overrides['cols:' + menuKey];
      if (colsData && colsData.cols) {
        const childCount = this.querySelectorAll(':scope > .mms__block, :scope > .mms__promo-cell').length;
        this.style.setProperty('--mms-cols', Math.max(1, Math.min(colsData.cols, childCount || colsData.cols)));
      }

      // Kategorier markerade "stapla" delar kolumn med kategorin före (halva höjden var)
      Array.from(this.querySelectorAll(':scope > .mms__block')).forEach((block) => {
        const data = this.getOverride(block, overrides);
        const prev = block.previousElementSibling;
        if (!data || !data.stack || !prev) return;
        let stack = prev.classList.contains('mms__stack') ? prev : null;
        if (!stack) {
          stack = document.createElement('div');
          stack.className = 'mms__stack';
          prev.replaceWith(stack);
          stack.appendChild(prev);
        }
        stack.appendChild(block);
      });

      this.insertPromo();
      this.applyCards(overrides);
      this.markGrid();

      this.querySelectorAll('.mms__block').forEach((block) => {
        this.applyItemImages(block, overrides);
        this.applyOverride(block, overrides);
        const img = block.querySelector('img.mms__img');
        const list = block.querySelector('.mms__list');
        if (!img || !list) return;

        const original = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
        let current = null;

        const show = (src, srcset) => {
          if (current === src) return;
          current = src;
          img.classList.add('is-swapping');
          const swap = () => {
            if (srcset) img.setAttribute('srcset', srcset);
            else img.removeAttribute('srcset');
            img.setAttribute('src', src);
            img.classList.remove('is-swapping');
          };
          const pre = new Image();
          pre.onload = pre.onerror = swap;
          pre.src = src;
        };

        const onEnter = (event) => {
          const item = event.target.closest('[data-mms-src]');
          if (item) show(item.dataset.mmsSrc, null);
        };

        list.addEventListener('mouseover', onEnter);
        list.addEventListener('focusin', onEnter);
        list.addEventListener('mouseleave', () => show(original.src, original.srcset));
        list.addEventListener('focusout', (e) => {
          if (!list.contains(e.relatedTarget)) show(original.src, original.srcset);
        });
      });
    }
  }

  // Kampanjbild (t.ex. Nyheter) fyller den tomma platsen på sista raden
  // Kampanjbild som ersätter en kategori (t.ex. Begagnat) läggs på kategorins plats
  MegaMenuShowcase.prototype.insertPromo = function () {
    if (this.querySelector(':scope > .mms__promo-cell')) return;
    const first = this.querySelector('.mms__block');
    if (!first) return;
    const parentKey = (first.dataset.mmsKey || '').split('|')[0];
    const tpls = Array.from(document.querySelectorAll('template[data-mms-promo]')).filter(
      (t) => (t.dataset.mmsPromo || '') === parentKey
    );
    if (!tpls.length) return;

    const makeCell = (tpl) => {
      const cell = document.createElement('div');
      cell.className = 'mms__promo-cell';
      cell.appendChild(tpl.content.cloneNode(true));
      return cell;
    };

    // 1. Ersätt kategorier
    tpls
      .filter((t) => t.dataset.mmsReplace)
      .forEach((tpl) => {
        const block = Array.from(this.querySelectorAll(':scope > .mms__block')).find(
          (b) => (b.dataset.mmsKey || '') === parentKey + '|' + tpl.dataset.mmsReplace
        );
        if (block) block.replaceWith(makeCell(tpl));
      });

    // 2. Fyll den tomma platsen sist i rutnätet
    const filler = tpls.find((t) => !t.dataset.mmsReplace);
    if (!filler) return;
    const cols = parseInt(getComputedStyle(this).getPropertyValue('--mms-cols'), 10) || 3;
    const rest = this.children.length % cols;
    const span = rest === 0 ? cols : cols - rest;
    const cell = makeCell(filler);
    cell.style.gridColumn = 'span ' + span;
    this.appendChild(cell);
  };

  // Markera första kolumnen och sista raden så att linjerna blir rätt oavsett antal kolumner
  MegaMenuShowcase.prototype.markGrid = function () {
    const cols = parseInt(getComputedStyle(this).getPropertyValue('--mms-cols'), 10) || 3;
    const cells = Array.from(this.children);
    let col = 0;
    let row = 0;
    const rows = [];
    cells.forEach((cell) => {
      const match = /span\s+(\d+)/.exec(cell.style.gridColumn || '');
      const span = Math.min(cols, match ? parseInt(match[1], 10) : 1);
      if (col + span > cols) {
        col = 0;
        row += 1;
      }
      cell.classList.toggle('mms-cell--first', col === 0);
      rows.push(row);
      col += span;
      if (col >= cols) {
        col = 0;
        row += 1;
      }
    });
    const lastRow = rows.length ? rows[rows.length - 1] : 0;
    cells.forEach((cell, i) => cell.classList.toggle('mms-cell--last-row', rows[i] === lastRow));
    this.classList.add('mms--marked');
  };

  // Bildkort (t.ex. Underhåll): egen bild och text från block "Länkbild"
  MegaMenuShowcase.prototype.applyCards = function (overrides) {
    const parentKey = this.dataset.mmsParent || '';
    this.querySelectorAll('.mms__promo[data-mms-card]').forEach((card) => {
      const title = card.dataset.mmsCard;
      const data = overrides['item:' + parentKey + '|' + title] || overrides['item:|' + title];
      if (!data) return;
      if (data.src) {
        let img = card.querySelector('img.mms__promo-img');
        if (!img) {
          img = document.createElement('img');
          img.className = 'mms__promo-img';
          img.loading = 'lazy';
          img.alt = '';
          card.prepend(img);
        }
        img.removeAttribute('srcset');
        img.removeAttribute('width');
        img.removeAttribute('height');
        img.setAttribute('src', data.src.replace(/([?&])width=600\b/, '$1width=900'));
      }
      if (data.text) {
        const text = card.querySelector('.mms__promo-text');
        if (text) {
          text.textContent = data.text;
          text.hidden = false;
        }
      }
    });
  };

  MegaMenuShowcase.prototype.getOverride = function (block, overrides) {
    const key = block.dataset.mmsKey || '';
    const cat = key.split('|').slice(1).join('|');
    return overrides[key] || overrides['|' + cat] || null;
  };

  // Egna bilder per länk (block "Länkbild" i Mega-meny: bilder)
  MegaMenuShowcase.prototype.applyItemImages = function (block, overrides) {
    const parentKey = (block.dataset.mmsKey || '').split('|')[0];
    block.querySelectorAll('.mms__item').forEach((a, index) => {
      const title = a.textContent.trim().toLowerCase();
      const data = overrides['item:' + parentKey + '|' + title] || overrides['item:|' + title];
      if (!data || !data.src) return;
      a.dataset.mmsSrc = data.src;
      if (index === 0) block.dataset.mmsFirstItemSrc = data.src;
    });
  };

  MegaMenuShowcase.prototype.applyOverride = function (block, overrides) {
    let data = this.getOverride(block, overrides);
    // Ingen egen kategoribild: använd första länkens egna bild om den finns
    if ((!data || !data.src) && block.dataset.mmsFirstItemSrc) {
      data = Object.assign({}, data || {}, { src: block.dataset.mmsFirstItemSrc, srcset: '' });
    }
    if (!data) return;

    if (data.src) {
      const media = block.querySelector('.mms__media');
      let img = media.querySelector('img.mms__img');
      if (!img) {
        media.innerHTML = '';
        img = document.createElement('img');
        img.className = 'mms__img';
        img.loading = 'lazy';
        media.appendChild(img);
      }
      img.setAttribute('src', data.src);
      if (data.srcset) img.setAttribute('srcset', data.srcset);
      else img.removeAttribute('srcset');
      img.setAttribute('sizes', '(min-width: 1200px) 220px, 18vw');
      img.removeAttribute('width');
      img.removeAttribute('height');
      img.alt = data.alt || '';
    }

    if (data.tagline) {
      const title = block.querySelector('.mms__title');
      const p = document.createElement('p');
      p.className = 'mms__tagline';
      p.textContent = data.tagline;
      title.insertAdjacentElement('afterend', p);
    }
  };

  customElements.define('mega-menu-showcase', MegaMenuShowcase);
}

(function initMegaMenuHover() {
  if (window.__megaMenuHoverInit) return;
  window.__megaMenuHoverInit = true;

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const desktop = window.matchMedia('(min-width: 990px)');
  const enabled = () => canHover.matches && desktop.matches;

  // Låt den öppna menyn sträcka sig ned till slidebildernas underkant,
  // så att menyns vita bakgrund möter den vita ytan under slidern.
  const findSlider = () =>
    document.querySelector('main slideshow-component .slideshow, main .slideshow, main slider-component.slider-mobile-gutter');

  const fitToSlider = (details) => {
    const content = details.querySelector('.mega-menu__content');
    if (!content) return;
    content.style.minHeight = '';
    content.classList.remove('mega-menu__content--fitted');
    if (!details.open || !desktop.matches) return;

    const slider = findSlider();
    if (!slider) return;

    // offsetTop påverkas inte av öppningsanimationens transform
    const parent = content.offsetParent;
    const contentTop = parent
      ? parent.getBoundingClientRect().top + content.offsetTop
      : content.getBoundingClientRect().top;
    const sliderRect = slider.getBoundingClientRect();
    // Bara när slidern ligger direkt under headern (överst på sidan)
    if (sliderRect.top > contentTop + 10 || sliderRect.bottom <= contentTop) return;

    const height = Math.round(sliderRect.bottom - contentTop);
    if (height > content.offsetHeight) {
      content.style.minHeight = height + 'px';
      content.classList.add('mega-menu__content--fitted');
    }
  };

  // ---------- Förladdning av bilder ----------
  // Bilderna i en stängd meny laddas annars först när menyn öppnas,
  // och hover-bilderna först när man pekar på länken. Här värms de upp i förväg.
  const preloaded = new Set();
  const preload = (src) => {
    if (!src || preloaded.has(src)) return;
    preloaded.add(src);
    const img = new Image();
    img.decoding = 'async';
    img.src = src;
  };

  const warmMenu = (details, includeHover) => {
    if (!details) return;
    details.querySelectorAll('img.mms__img, img.mms__promo-img').forEach((img) => {
      // eager = bilden hämtas direkt även om menyn är stängd (rätt storlek väljs via srcset)
      if (img.loading !== 'eager') img.loading = 'eager';
    });
    if (includeHover) {
      details.querySelectorAll('[data-mms-src]').forEach((a) => preload(a.dataset.mmsSrc));
    }
  };

  const warmAll = () => {
    const all = Array.from(document.querySelectorAll('.header__inline-menu details.mega-menu--showcase'));
    // Först kategoribilderna i alla menyer, sedan hover-bilderna – lite i taget
    all.forEach((d) => warmMenu(d, false));
    let i = 0;
    const next = () => {
      if (i >= all.length) return;
      warmMenu(all[i++], true);
      (window.requestIdleCallback || ((cb) => setTimeout(cb, 300)))(next);
    };
    next();
  };

  const scheduleWarmAll = () => {
    if (!desktop.matches) return;
    const run = () => (window.requestIdleCallback || ((cb) => setTimeout(cb, 1500)))(warmAll, { timeout: 4000 });
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  };

  const setup = () => {
    const menus = Array.from(document.querySelectorAll('.header__inline-menu header-menu'));

    // Så fort musen närmar sig en menyrubrik laddas just den menyns bilder direkt
    menus.forEach((menu) => {
      const details = menu.querySelector('details.mega-menu');
      if (!details || details.dataset.warmReady) return;
      details.dataset.warmReady = 'true';
      const summary = details.querySelector('summary');
      const warm = () => warmMenu(details, true);
      summary.addEventListener('pointerenter', warm, { once: true });
      summary.addEventListener('focus', warm, { once: true });
      summary.addEventListener('touchstart', warm, { once: true, passive: true });
    });

    menus.forEach((menu) => {
      const details = menu.querySelector('details.mega-menu');
      if (!details || details.dataset.fitReady) return;
      details.dataset.fitReady = 'true';
      details.addEventListener('toggle', () => requestAnimationFrame(() => fitToSlider(details)));
    });

    if (!window.__megaMenuFitResize) {
      window.__megaMenuFitResize = true;
      window.addEventListener('resize', () => {
        document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach(fitToSlider);
      });
    }

    menus.forEach((menu) => {
      const details = menu.querySelector('details.mega-menu');
      if (!details || details.dataset.hoverReady) return;
      details.dataset.hoverReady = 'true';
      const summary = details.querySelector('summary');
      let closeTimer;

      const open = () => {
        if (!enabled()) return;
        clearTimeout(closeTimer);
        menus.forEach((other) => {
          if (other !== menu && typeof other.close === 'function') other.close();
        });
        if (!details.open) {
          details.open = true;
          summary.setAttribute('aria-expanded', 'true');
        }
      };

      const scheduleClose = () => {
        if (!enabled()) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          if (typeof menu.close === 'function') menu.close();
        }, 180);
      };

      details.addEventListener('mouseenter', open);
      details.addEventListener('mouseleave', scheduleClose);

      // Musklick på rubriken ska inte stänga en meny som just öppnats med hover.
      // Tangentbord (event.detail === 0) fungerar som vanligt.
      summary.addEventListener('click', (event) => {
        if (enabled() && event.detail > 0 && details.open) event.preventDefault();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  scheduleWarmAll();
  document.addEventListener('shopify:section:load', setup);
})();
